import React from 'react';
import DataManagement from './DataManagement';
import { useAuth } from '../../contexts/AuthContext';
import { useTheme } from '../../hooks/useTheme';
import { storage } from '../../utils/storage';

const Settings = () => {
  const { user } = useAuth();
  const { theme, toggleTheme, fontSize, setFontSize } = useTheme();

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold mb-2">Settings</h1>
        <p className="text-gray-600">Manage your preferences and data</p>
      </div>

      {/* Appearance */}
      <div className={`p-6 rounded-xl ${theme === 'dark' ? 'bg-gray-800' : 'bg-white'} shadow-lg`}>
        <h3 className="font-semibold mb-4">Appearance</h3>
        
        <div className="space-y-4">
          <div className="flex items-center justify-between">
            <div>
              <h4 className="font-medium">Dark Mode</h4>
              <p className="text-sm text-gray-500">Reduce eye strain in low light</p>
            </div>
            <button
              onClick={toggleTheme}
              className={`relative inline-flex h-6 w-11 items-center rounded-full ${
                theme === 'dark' ? 'bg-blue-600' : 'bg-gray-200'
              }`}
            >
              <span
                className={`inline-block h-4 w-4 transform rounded-full bg-white transition ${
                  theme === 'dark' ? 'translate-x-6' : 'translate-x-1'
                }`}
              />
            </button>
          </div>

          <div>
            <h4 className="font-medium mb-2">Font Size</h4>
            <div className="grid grid-cols-4 gap-2">
              {['small', 'normal', 'large', 'xlarge'].map(size => (
                <button
                  key={size}
                  onClick={() => {
                    setFontSize(size);
                    storage.set('fontSize', size);
                  }}
                  className={`px-3 py-2 rounded-lg capitalize ${
                    fontSize === size
                      ? 'bg-blue-600 text-white'
                      : theme === 'dark' ? 'bg-gray-700' : 'bg-gray-100'
                  }`}
                >
                  {size}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>

      <DataManagement />

      {/* Account Info */}
      <div className={`p-6 rounded-xl ${theme === 'dark' ? 'bg-gray-800' : 'bg-white'} shadow-lg`}>
        <h3 className="font-semibold mb-4">Account Information</h3>
        <div className="space-y-2">
          <div className="flex justify-between py-2">
            <span className="text-gray-600">Name</span>
            <span className="font-medium">{user?.name}</span>
          </div>
          <div className="flex justify-between py-2">
            <span className="text-gray-600">Student ID</span>
            <span className="font-medium">{user?.studentId}</span>
          </div>
          <div className="flex justify-between py-2">
            <span className="text-gray-600">Year</span>
            <span className="font-medium">Year {user?.year}</span>
          </div>
          <div className="flex justify-between py-2">
            <span className="text-gray-600">Joined</span>
            <span className="font-medium">
              {new Date(user?.joinedAt).toLocaleDateString()}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings;